import { render, staticRenderFns } from "./need-solution-pending.vue?vue&type=template&id=f9475008&scoped=true&"
import script from "./need-solution-pending.vue?vue&type=script&lang=js&"
export * from "./need-solution-pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9475008",
  null
  
)

export default component.exports